module.exports = {
    fields: {
        email: "e-mail",
        password: "mot de passe",
        userName: 'compte',
        code: 'Code',
        confirm: 'Confirmer le mot de passe',

    },
    validation: {
        "required": 'Le {_field_} ne peut pas être vide',
        "min": 'Le {_field_} ne peut être inférieur à 6 chiffres',
        "userName": 'Le {_field_} 4 à 16 bits (souligné alphanumériquement)',
        "confirmed": 'Les deux mots de passe ne correspondent pas',
        "code": '{_field_} est un nombre à 6 chiffres',
        "email":'{_field_} Erreur de formatage',
    }
}